<template>
  <div class="currencies-selector">
    <p class="subtitle2">{{ $t('organization.currencies_enabled') }}</p>

    <v-select
      outlined
      required
      dense
      id="currency"
      data-testid="currenciesSelector-select-defaultCurrency"
      :value="defaultCurrency"
      :items="currencies"
      :label="`${$t('organization.currency')}*`"
      :rules="[
        currency => !!currency || $t('validation.form.this_field_is_required'),
      ]"
      @input="$emit('setDefaultCurrency', $event)"
    ></v-select>

    <v-row
      v-for="(allowedSiteCurrency, index) in allowedSiteCurrencies"
      v-bind:key="index"
    >
      <v-col cols="6">
        <v-autocomplete
          outlined
          required
          dense
          class="me-4"
          v-model="allowedSiteCurrency.currency"
          :id="`allowedSiteCurrencySelectCurrency-${index}`"
          :data-testid="`allowedSiteCurrency-select-currency-${index}`"
          :items="filteredCurrencies"
          :label="`${$t('common.currency')}*`"
          :placeholder="$t('common.currency')"
          :rules="[
            currency =>
              !!currency || $t('validation.form.this_field_is_required'),
            currency =>
              !currencyIsDuplicated() ||
              $t('organization.duplicated_currency', {
                currency,
              }),
          ]"
          @input="validateCurrency($event, index)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="5">
        <v-text-field
          outlined
          required
          dense
          class="pa-0 ma-0"
          type="number"
          v-model="allowedSiteCurrency.exchangeRateFromGlobal"
          :id="`allowedSiteCurrencyExchangeRate-${index}`"
          :testId="`allowedSiteCurrency-text-exchange-${index}`"
          :label="`${$t('organization_settings.exchange_rate')}*`"
          :rules="[
            currency =>
              !!currency || $t('validation.form.this_field_is_required'),
            currency =>
              currency > 0 ||
              $t('organization.the_exchange_rate_must_be_greater_than_zero'),
          ]"
        >
        </v-text-field>
      </v-col>
      <v-col cols="1">
        <v-icon
          v-if="allowedSiteCurrency.currency !== defaultCurrency"
          class="grey--text icon mt-3"
          :data-testid="`currency-icon-delete`"
          @click="removeCurrency(index)"
        >
          mdi-delete-outline
        </v-icon>
      </v-col>
    </v-row>
    <Button
      v-if="defaultCurrency"
      plain
      testId="currenciesSelector-button-add-another"
      color="primary"
      :text="$t('organization.add_another_currency')"
      @click="addNewAllowedCurrency"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import currencies from '@/locales/currencies.json'
import Button from '@/components/UI/Button'

export default {
  props: {
    defaultCurrency: {
      required: false,
    },
    allowedSiteCurrencies: {
      type: Array,
    },
  },

  components: {
    Button,
  },

  data() {
    return {
      errors: {
        currency: {},
        exchangeRate: {},
      },
      currencies: Object.values(currencies).map(({ name, code }) => ({
        value: code,
        text: `${code} - ${name}`,
      })),
    }
  },

  computed: {
    filteredCurrencies() {
      return this.currencies.filter(c => c.value !== this.defaultCurrency)
    },
  },

  methods: {
    validateCurrency(currencyCode, index) {
      if (this.currencyIsDuplicated()) {
        this.errors.currency[index] = this.$t(
          'organization.duplicated_currency',
          {
            currencyCode,
          }
        )

        return false
      }

      this.errors.currency[index] = null
    },

    addNewAllowedCurrency() {
      this.allowedSiteCurrencies.push({
        exchangeRateFromGlobal: 1,
        currency: null,
      })
    },

    removeCurrency(index) {
      this.allowedSiteCurrencies.splice(index, 1)
      this.errors.exchangeRate = {}
      this.errors.currency = {}
    },

    currencyIsDuplicated() {
      let codes = _.map(this.allowedSiteCurrencies, 'currency')
      codes = codes.filter(code => code !== null)
      return new Set(codes).size !== codes.length
    },
  },
}
</script>
